import React from "react";
import { Link } from "react-router-dom";

import CreateRegionForm from "../components/CreateRegionForm";

// Adding Region
const AddRegion = () => {
  return (
    <>
      <section className="body-font relative text-gray-600">
        <div className="container mx-auto flex px-5 py-4">
          <div className="flex w-full flex-col items-end rounded-lg bg-white p-8">
            <div className="flex flex-col md:flex-row-reverse items-center justify-between w-full py-4 border-b mb-8">
              <h2 className="title-font text-lg font-medium text-gray-900">إضافة منطقة جديدة</h2>
              <Link
                className="text-lg text-blue-500 font-bold underline"
                to={`${process.env.PUBLIC_URL}/regions`}
              >
                الرجوع لصفحة المناطق
              </Link>
            </div>

            <CreateRegionForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default AddRegion;
